import { IChatCommand, ThreadsFilter, MessagesFilter } from './models';
import { Region, User } from '../shared/models';
import { ApiService, UserService, ConfigService } from '../shared/services';
import { ChatMessage, Thread } from './models';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import * as moment from 'moment';

const dateFormat = 'MM/DD/YYYY hh:mm:ss A';

const _commandBusSubject = new Subject<IChatCommand>();
const _currentThreadSubject = new Subject<Thread>();

export const VirtualAllRegionsElement = { id: -1,
                                          name: 'All Regions',
                                          useKits: false,
                                          locations: []
                                        };

@Injectable()
export class ChatService {

    private _baseUrl = this.configService.getContext('bi').url;
    private _messagesPath =  'feeds/messages';
    private _threadsPath = 'feeds/threads';
    private _user: User;

    commandBus$: Observable<IChatCommand>;
    private _commandBusSubject = _commandBusSubject;

    private _currentThread: Thread;
    private _threads = new Array<Thread>();

    private _threadSubject =  _currentThreadSubject;
    private _messagesSubject = new Subject<ChatMessage[]>();

    messages: ChatMessage[];

    messages$: Observable<ChatMessage[]>;

    // Mapping  Static functions

    public static getMessageById(id: number, messages: ChatMessage[]): ChatMessage {
        let message =   messages.filter(m => { return m.region.id === id; })[0];
        return message;
    }

    public static mapMessages(res: any): ChatMessage[] {
        return res.data.map(m => { return new ChatMessage(m); });
    }

    public static mapThreads(res: any): ChatMessage[] {
        return res.map(m => { return new ChatMessage(m); });
    }


    constructor(private _userService: UserService,
                private _apiService: ApiService,
                private configService: ConfigService) {
      
        this._userService.user$.subscribe(user => this._user = user);

        this.commandBus$ = this._commandBusSubject.asObservable().distinctUntilChanged();
        this.messages$ = this._messagesSubject.asObservable().distinctUntilChanged();
    };

    get user(): User {
        return this._user;
    }

    get thread(): Thread {
        return this._currentThread;
    }

    get threads(): Thread[] {
        return this._threads;
    }

    get thread$(): Observable<Thread> {
        return this._threadSubject.asObservable().distinctUntilChanged();
    }

    setThread(thread: Thread) {
        this._currentThread = thread;
        this._threadSubject.next(this._currentThread);
    }

    joinRegion(region: Region) {
        let thread = this._threads.find(thread => thread.region === region);

        if (!thread) {
            thread = this.createThread(region);
        } else {
            thread.messages = new Array<ChatMessage>();
            this._messagesSubject.next();
        };

        this.setThread(thread);
    }

    createThread(region: Region): Thread {
        let thread = new Thread(region);

        this._threads.push(thread);
        return thread;
    }

    sendChatMessageToSignalR(text: string) {
         let timestamp = moment(Date()).format(dateFormat);
         let regions: Region[] = [this._currentThread.region];

         if (this._currentThread.region.id === -1) {
             regions = this._user.regions;
         }

         regions.forEach( r => {
            this.pushChatCommand({ id: 'sendMessageToSignalR',
                                data: { region: r,
                                        text: text,
                                        timestamp: timestamp
                                      }
                             });
         });
    }

    proccessIncomingMessage(data: any) {
        let message = new ChatMessage(data.message);
        message.text = data.message.message;
        message.name = data.message.user;
        let timestamp = moment(Date()).format(dateFormat);
        message.timestamp = timestamp;
        this._currentThread.messages.push(message);
        this._messagesSubject.next(this._currentThread.messages);
    }

    pushChatCommand(command: IChatCommand) {
        this._commandBusSubject.next({
                id:     command.id,
                data:   command.data
            });
    }

    getMessageHistory(regions: number[] = [this._currentThread.region.id],
                      page = 1,
                      size = 10): Observable<ChatMessage[]> {
       let messageFilter = new MessagesFilter({regions: regions,
                                               page: page,
                                               size: size});
       return this._apiService.get(this._baseUrl, this._messagesPath, messageFilter)
                .map(res => {
                        let result = ChatService.mapMessages(res);
                        this._currentThread.messages = result;
                        this._messagesSubject.next(result);
                        return result;
                    });
   }

   pullThreadsLastMessage(): Observable<ChatMessage[]> {
       let regionsArray: number[] = this.threads.map(t => { return (t.region.id); } );
       let threadFilter = new ThreadsFilter({regions: regionsArray});
       return this._apiService.get(this._baseUrl, this._threadsPath, threadFilter)
                .map(res => {
                        let result = ChatService.mapThreads(res);
                        this.updateThreadLastMessage(result);
                        return result;
                    });
   }

   updateThreadLastMessage(messages: ChatMessage[]) {
        this.threads.forEach( t => {
            t.messages = new Array<ChatMessage>();
            t.messages.push(ChatService.getMessageById(t.region.id, messages));
        });
   }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/chat.service.ts